var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import store from "../../store";
import VueDialog from "../../interface/IVueDialog";
import { Component } from 'vue-property-decorator';
import { EServiceStatus } from "../../enum/EStatus";
import ServiceService from '../../api/ServiceService';
import { Loading } from 'element-ui';
import _ from 'lodash';
var DetailDialog = (function (_super) {
    __extends(DetailDialog, _super);
    function DetailDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpenOperate = false;
        _this.paymentMode = 2;
        _this.serviceInfo = {};
        _this.paymentModesList = [];
        _this.paymentInfo = {};
        _this.serviceStatus = EServiceStatus;
        return _this;
    }
    DetailDialog.prototype.created = function () {
        this.service = ServiceService.getInstance();
    };
    DetailDialog.prototype.mounted = function () {
        this.isOpenOperate = this.isOpenOperate || false;
        this.serviceInfo = this.serviceInfo;
        this.paymentInfo = this.serviceInfo.payment_modes.find(function (item) {
            return item.payment_mode == 2;
        });
        _.forEach(this.serviceInfo.payment_modes, function (item) {
            item.describeArr = item.describe.split('\r\n\r\n');
        });
        this.paymentModesList = this.serviceInfo.payment_modes;
    };
    DetailDialog.prototype.toUse = function () {
        var _this = this;
        var params = { service_id: this.serviceInfo.service_id };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.trialService(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success('试用成功！');
                _this.$emit('trialSuccess');
                _this.service.getServiceWarning().then(function (res) {
                    store.dispatch('updateServiceData', res.data.data);
                    store.dispatch('updateServiceFlag', res.data.data.flag == 2 || false);
                    _this.$closeDialog();
                }, function (error) {
                    _this.$message.error(error.message);
                });
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    DetailDialog.prototype.toPay = function () {
        if (!this.paymentMode)
            return;
        this.$emit('toOpenPay', this.serviceInfo, this.paymentInfo);
        this.$closeDialog();
    };
    DetailDialog.prototype.close = function () {
        this.$closeDialog();
    };
    DetailDialog.prototype.showRow = function (row) {
        var index = this.paymentModesList.indexOf(row);
        this.paymentInfo = row;
        this.paymentMode = this.paymentModesList[index].payment_mode;
    };
    DetailDialog = __decorate([
        Component({
            components: {}
        })
    ], DetailDialog);
    return DetailDialog;
}(VueDialog));
export default DetailDialog;
